import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { putCoreSonarObjectsUsersBulkSlice } from './put';

export const coreSonarObjectsUsersBulkReducers = combineReducers({
	put: putCoreSonarObjectsUsersBulkSlice.asyncReducers
});

export const coreSonarObjectsUsersBulkWatchers = combineAllWatchers([
	putCoreSonarObjectsUsersBulkSlice.asyncWatchers
]);
